import { render } from "./singleFile.vue?vue&type=template&id=2d5a70c8&scoped=true"
import script from "./singleFile.vue?vue&type=script&lang=js"
export * from "./singleFile.vue?vue&type=script&lang=js"

import "./singleFile.vue?vue&type=style&index=0&id=2d5a70c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d5a70c8"]])

export default __exports__